import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalController, Platform } from '@ionic/angular';
import { ImagesSettingsService } from '@services/settings';
import { MediaSource } from '../../schema/enums/media-source';
import { ICustomFile } from '../../schema/interfaces/ICustomFile';
import { FileChooserService } from '../../services/file-chooser/file-chooser.service';

@Component({
  templateUrl: 'camera.component.html',
  styleUrls: ['camera.component.scss']
})
export class CameraComponent implements OnInit, AfterViewInit {
  @Input()
  readonly mediaSource: MediaSource;

  previewImg: string | SafeUrl = null;
  text: string = '';

  private _selectedFile: ICustomFile = null;
  get selectedFile() {
    return this._selectedFile;
  }

  constructor(
    private modalController: ModalController,
    private platform: Platform,
    private imageSettings: ImagesSettingsService,
    private fileChooser: FileChooserService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.onChoose();
  }

  onChoose(): void {
    this.fileChooser.choose(this.mediaSource).then(
      customFile => {
        this._selectedFile = customFile;
        this.showPreview(this._selectedFile);
      },
      err => {
        if (this._selectedFile === null) {
          this.onCancel();
        }
      }
    );
  }

  private showPreview(customFile: ICustomFile) {
    let imageUrl: string;
    if (this.mediaSource === MediaSource.Video) {
      imageUrl = this.imageSettings.get('VideoAttachments');
    } else {
      imageUrl = customFile.url;
    }

    if (this.platform.is('ios')) {
      this.previewImg = this.domSanitizer.bypassSecurityTrustUrl(imageUrl);
    } else {
      this.previewImg = imageUrl;
    }
  }

  onCancel() {
    return this.modalController.dismiss(null);
  }

  onAccept() {
    if (this._selectedFile) {
      this._selectedFile.text = this.text;
    }
    return this.modalController.dismiss(this._selectedFile);
  }
}
